import { Stack } from '@mantine/core';
import { IconPlus } from '@tabler/icons-react';
import { omit } from 'lodash';
import { IConfigureInputParams } from 'pages/revisions-module/template-editor/editors/form/configurator/InputConfiguratorProvider';
import { ALL_TYPES_ON } from 'pages/revisions-module/template-editor/editors/form/configurator/InputTypeSelect';
import FormSection from 'pages/revisions-module/template-editor/editors/form/section/FormSection';
import { useFormSections } from 'pages/revisions-module/template-editor/editors/form/section/FormSectionsDataProvider';
import { IFormInputType, IFormTabSlug } from 'pages/revisions-module/template-editor/editors/form/types';
import { useMemo } from 'react';
import { useResponsiveDesign } from 'hooks/use-responsive-design';
import Button from 'components/Button';

/**
 * Parameters for the FormTab component.
 */
export interface FormTabProps {
  slug: IFormTabSlug;
}

/**
 * A single tab in the form editor.
 */
export default function FormTab({ slug }: FormTabProps) {
  const { isTablet } = useResponsiveDesign();
  const { sections, addSection } = useFormSections();

  const sectionsInTab = useMemo(() => sections.filter((section) => section.tab === slug), [sections, slug]);

  const configureInputParams: Partial<IConfigureInputParams> = useMemo(
    () => ({
      inputTypes: omit(ALL_TYPES_ON, [
        'deviceProperty',
        'deviceEvidenceField',
        'faultType',
        'faultSeverity',
        'numberOfMeasurements',
        'measurementColumnAggregator',
      ] as IFormInputType[]),
      hidden: { minWidth: true, maxWidth: true },
    }),
    []
  );

  return (
    <Stack spacing={isTablet ? 20 : 40}>
      {sectionsInTab.map((section, index) => (
        <FormSection
          key={section.id}
          data={section}
          context="revision"
          configureInputParams={configureInputParams}
          isFirst={index === 0}
          isLast={index === sectionsInTab.length - 1}
        />
      ))}
      <Button variant="tertiary" size="lg" leftIcon={<IconPlus />} ml={40} onClick={() => addSection(slug)}>
        Pridať sekciu
      </Button>
    </Stack>
  );
}
